import { get, post } from './util';

export default class Unblock {
  constructor(base) {
    this.base = base;
  }

  listACL(group='dev') {
    return get(`${this.base}/acl`, {group});
  }

  createUnblock(group, ip, note, ttl) {
    return post(`${this.base}/unblock`, {group, ip, note, ttl})
  }

  scale(env, action) {
    return get(`${this.base}/scale/:env/:action`, {env, action})
  }

  ip() {
    return get(`${this.base}/ip`);
  }

  isAdmin() {
    return get(`${this.base}/is-admin`);
  }

  fetchToken(uuid) {
    return get(`${this.base}/fetch-token`, {uuid});
  }

  listBuilds(app, ref, page=1, size=10) {
    const q = {app, page, size}
    if (ref) q.ref = ref
    return get(`${this.base}/builds`, q)
  }

  queryBuilds(app, ref, page=1, size=10) {
    const q = {app, page, size}
    if (ref) q.ref = ref
    return get(`${this.base}/builds/query`, q)
  }

}
